<template v-if="tribuneSeats">
    <table v-if="tribuneSeats">
        <tr v-for="(row, rownr) in tribuneSeats.rows">
            <template v-for="(seat, index) in row.items">
                <template v-if="seat === 'empty'">
                    <td v-bind:key="rownr + index" class="empty"></td>
                </template>
                <template v-else-if="seat === 'stairs'">
                    <td v-bind:key="rownr + index" class="stairs"></td>
                </template>
                <template v-else-if="reservedSeats && (reservedSeats.includes(seat) && !selectedSeats.includes(seat) && seat !== originalSelectedSeat)">
                    <td v-bind:key="rownr + index" class="reserved">{{seat}}</td>
                </template>
                <template v-else-if="selectedSeats.includes(seat)">
                    <td v-bind:key="rownr + index" class="selected" @click="() => {selecting = !selecting; if (selecting) selectCells(row.name, seat)}" @mouseover="() => { if (selecting) selectCells(row.name, seat) }">{{seat}}</td>
                </template>
                <template v-else>
                    <td v-bind:key="rownr + index" @click="() => {selecting = !selecting; if (selecting) selectCells(row.name, seat)}" @mouseover="() => { if (selecting) selectCells(row.name, seat) }">{{seat}}</td>
                </template>
            </template>
        </tr>
    </table>
</template>

<script>
import tribunes from "../tribunes";
import { _ } from "vue-underscore";
export default {
  name: "SeatSelection",
  props: {
    selectedTribuneKey: String,
    selectedTribune: Object,
    tickets: Object,
    reservedSeats: Array,
    selectedSeat: Number // In case of a subscription
  },
  data() {
    return {
      selectedSeats: [],
      selecting: true,
      originalSelectedSeat: null
    };
  },
  computed: {
    numberOfSeats: function() {
      let totalSeats = 0;
      if (this.tickets) {
        Object.keys(this.tickets).forEach(key => {
          totalSeats = totalSeats + this.tickets[key];
        });
      }

      return totalSeats > 0 ? totalSeats : 1;
    },
    tribuneSeats: function() {
      if (this.selectedTribune && this.selectedTribune.type === "sit") {
        return tribunes[this.selectedTribune.block];
      }
    }
  },
  watch: {
    selectedSeat: function(newVal) {
      if (newVal !== null) {
        this.selectedSeats = [];
        this.selecting = false;
        this.selectedSeats.push(newVal);
      }
    },
    tickets: function() {
      this.selecting = true;
    }
  },
  methods: {
    closeDialog: function() {
      this.$emit("closeDialog", true);
      this.resetSeatSelection();
    },
    resetSeatSelection: function() {
      this.selectedSeats = [];
      this.selecting = true;
      this.originalSelectedSeat = null;
    },
    selectCells: function(rownr, seat) {
      const availableSeats = _.difference(
        tribunes[this.selectedTribune.block].seats,
        this.reservedSeats
      );
      const index = availableSeats.indexOf(seat);
      const selectedSeats = [];
      const numberOfSeats = this.numberOfSeats;
      for (let i = 0; i < numberOfSeats; i++) {
        selectedSeats.push(availableSeats[index + i]);
      }
      this.selectedSeats = selectedSeats;

      if (this.originalSelectedSeat === null && this.selectedSeat) {
        this.originalSelectedSeat = this.selectedSeat;
      }

      this.$emit("seatSelected", Number(rownr), Number(seat));
      this.$emit("seatsSelected", this.getSeatsSelected());
    },
    calculateSelectedSeats: function() {
      const selectedSeats = [];
      for (let i = 0; i < this.selectedSeats.length; i++) {
        const seat = this.selectedSeats[i];
        for (let j = 0; j < this.tribuneSeats.rows.length; j++) {
          const row = this.tribuneSeats.rows[j];
          if (row.items.includes(seat)) {
            selectedSeats.push({
              row: row.name,
              seat: seat
            });
          }
        }
      }

      return selectedSeats;
    },
    getSeatsSelected: function() {
      return {
        ...this.tickets,
        selectedSeats: this.calculateSelectedSeats()
      };
    }
  }
};
</script>
<style scoped>
th,
td {
  border: 1px solid #ccc;
  width: 50px;
  height: 30px;
  text-align: center;
  font-size: small;
}
td.stairs {
  background-image: repeating-linear-gradient(
    0deg,
    rgba(255, 255, 255, 0.6) 0px,
    rgba(255, 255, 255, 0.5) 3px,
    transparent 5px,
    transparent 10px
  );
}

td.reserved {
  background-color: red;
}
td.selected {
  background-color: green;
  cursor: pointer;
}
td.reserved:hover {
  background-color: red;
  cursor: not-allowed;
}
td.stairs:hover,
td.empty:hover {
  background-color: transparent;
  cursor: not-allowed;
}
</style>
